// extracted by mini-css-extract-plugin
export default {"melodyVideo":"_J-z","isFullWidth":"aK-z","landingPageVideo":"bK-z","play":"cK-z","iframeVideo":"dK-z","playHidden":"eK-z","fullwidth":"fK-z"};